import ReactGA from "react-ga4";

import config from "config";
import { IUser } from "Auth/types";
import { loggerService } from "./LoggerService";
import { ICookiePreferenceType } from "shared/types";
import { CookieService } from "./CookieService";

export class GoogleAnalyticsService {
  static isEnabled = () => CookieService.userCookiePreference() === ICookiePreferenceType.acceptAll;

  static initialize = (user?: IUser | null) => {
    if (GoogleAnalyticsService.isEnabled()) {
      loggerService.log({
        icon: "📊",
        title: "Google Analytics",
        body: "initialized",
      });

      ReactGA.initialize(config.googleAnalytics.trackingId);

      if (user) {
        GoogleAnalyticsService.setUser(user);
      }
    }
  };

  static setUser = (user: IUser | null) => {
    if (GoogleAnalyticsService.isEnabled()) {
      loggerService.log({
        icon: "📊",
        title: "Google Analytics User",
        body: user,
      });

      ReactGA.set({
        userId: user?.id,
        name: `${user?.attributes.firstname} ${user?.attributes.lastname}`,
      });
    }
  };

  static pageView = (page: string) => {
    if (GoogleAnalyticsService.isEnabled()) {
      loggerService.log({
        icon: "📊",
        title: "Google Analytics page view",
        body: page,
      });

      ReactGA.send({ hitType: "pageview", page });
    }
  };
}
